<template>
  <div v-if="value" class="router-card">
    <div class="router-icon" @click="gotoPage">
      <div class="fenghuang_icon" v-if="value.id===59">
      </div>
			<font-awesome-icon v-else class="icon" :icon="value.icon" size="3x"/>
		</div>
    <div class="router-name">{{value.name}}</div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: () => {
        return null;
      }
    }
	},
	methods:{
		gotoPage(){
			this.$router.push({
        path: this.value.path
      })
		}
	}
};
</script>

<style lang="scss" scoped>
.router-card {
	display: flex;
	flex-direction: column;
	align-items: center;
	cursor: pointer;
  .router-icon {
    width: 100px;
    height: 100px;
    background: #fff;
    box-shadow: 0px 2px 4px 0px rgba(86, 86, 86, 0.5);
    border-radius: 4px;
		margin-bottom: 18px;
		display: flex;
		align-items: center;
		justify-content: center;
		color:#f0722b;
		&:hover{
			background: #f0722b;
			color: #fff;
      .fenghuang_icon{
          background-image: url('../assets/white_logo.png');
      }

		}
    .fenghuang_icon{
      width: 50px;
      height: 50px;
      border: 0px;
      background-size:contain;
      background-image: url('../assets/logo.png');
    }
  }
	.router-name{
		font-size: 16px;
		color: #fff;
    width:110px;
    text-align: center;
  }
}
</style>
